import React from "react";

interface WorkLogTextDisplayProps {
  comment?: string | null;
  description?: string | null;
  compact?: boolean;
}

/**
 * Unified display for WorkLog comment + description.
 * - Shows comment first, then description
 * - Hides cleanly when both are empty
 * - Wraps long text, never truncates
 * - Readable contrast (text-gray-700 / gray-600)
 */
export default function WorkLogTextDisplay({ comment, description, compact = false }: WorkLogTextDisplayProps) {
  const c = (comment || "").trim();
  const d = (description || "").trim();
  if (!c && !d) return null;

  const baseBox = compact
    ? "mt-1.5 space-y-1"
    : "mt-2 space-y-1.5 bg-gray-50 rounded-lg px-3 py-2";

  return (
    <div className={baseBox}>
      {c && (
        <div className="flex gap-1.5 text-xs leading-relaxed">
          <span className="text-gray-400 shrink-0">📝</span>
          <span className="text-gray-700 whitespace-normal break-words">{c}</span>
        </div>
      )}
      {d && (
        <div className="flex gap-1.5 text-xs leading-relaxed">
          <span className="text-gray-400 shrink-0">📄</span>
          <span className="text-gray-600 whitespace-normal break-words">{d}</span>
        </div>
      )}
    </div>
  );
}
